//palette.tsx
export const palette = {
  Main_orange: "#FC843E",
  Sub1_orange: "#FF9C61",
  Sub2_orange: "#FFB589",
  Sub3_orange: "#FFDBC5",
  Sub4_orange: "#FFF3EB",
  BG_orange: "#FAF4F3",

  Blue: "#4FB2FA",
  Blue2: "#DFEEFF",
  Red: "#FA4F4F",
  Red2: "#FFDFDF",

  White: "#FFFFFF",
  Gray1: "#FBF7F8",
  Gray2: "#F5F4F2",
  Gray3: "#E8E4E2",
  Gray4: "#C6C2C1",
  Gray5: "#868281",
  Gray6: "#5C5856",
  Gray7: "#474644",
  Gray8: "#434240",
  Gray9: "#353432;",
  Black: "#000",
};
